import { useFormik } from "formik";
import classes from "./style.module.css";
import { Row, Col, Button } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { createBrowserHistory } from "history"
import { hasPermission } from "../../services/utils";
import { PERMISSIONS } from "../../contants/permission";

const UsersFilterForm = (props) => {

  const { onAddNew, setFilterData, setPage, template } = props;
  const initialValues = {
    name: "",
    status: "",
    email: "",
  };


  const formik = useFormik({
    initialValues,

    onSubmit: values => {

      if (Object.keys(values).length) {
        Object.keys(values).map((filterKey) => {
          if (!values[filterKey]) {
            delete values[filterKey];
          }
          return "";
        });
      }
      setFilterData((prev) => ({
        ...prev,
        ...values,
      }));
      setPage(1)
      createBrowserHistory().push(`/${template}?page=1`);
    },
  });

  const handleReset = () => {
    props.setLoading(false);
    props.setFilterData("");
    formik.values.name = "";
    formik.values.status = "";
    formik.values.email = "";

  };

  const addNewHandler = () => {
    onAddNew(true)
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Row className="mb-3">
        <Col md={4}>
          {
            hasPermission(PERMISSIONS.USERS.CREATE) && <div className="form-floating">
              <Button className={classes.button} onClick={addNewHandler}>
                {" "}
                Add User
              </Button>
            </div>
          }
        </Col>
        <Col md={8}>
          <Row>
            <Col>
              <label htmlFor="name">User Name</label>
              <input
                name="name"
                id="name"
                type="text"
                className="form-control"
                placeholder="Enter name"
                onChange={formik.handleChange}
                value={formik.values.name}
              />
            </Col>
            <Col>
              <label htmlFor="email">Email</label>
              <input
                name="email"
                id="email"
                type="email"
                className="form-control"
                placeholder="Enter email"
                onChange={formik.handleChange}
                value={formik.values.email}
              />
            </Col>

            <Col>
              <label htmlFor="status">Status</label>
              <select
                className="form-select"
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
                style={{ display: "block" }}
              >
                <option value="" label="Select a Status">
                  Select Status{" "}
                </option>
                <option value="0" label="Inactive">
                  {" "}
                  Inactive
                </option>
                <option value="1" label="Active">
                  Active
                </option>
              </select>
            </Col>
          </Row>
          <Row>
            <Col>
              {formik.touched.name && formik.errors.name ? (
                <span className="error text-danger">{formik.errors.name}</span>
              ) : null}
            </Col>
          </Row>
          <Row className="mt-3">
            <Col>
              <Button as="input" type="submit" value="Filter" xs={4} md={1} />{" "}
              <Button onClick={handleReset} type="reset" variant="secondary">
                Reset
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </form>
  );
};

export default UsersFilterForm;